// @flow

import {
  ADD,
  EDIT,
  DELETE,
  READ,
  UPDATE_OPERATION,
  UPDATE_OPERATIONS,
  SUBMIT_OPERATION,
  SUBMIT_OPERATIONS,
  CANCEL_OPERATION,
  CANCEL_OPERATIONS,
  // DELETE,
} from './constants'

import type {
  ActionTypes,
} from '../types'

type Args = {
  model: string,
}

const prefix = '@@ops'

export default function composeActionTypes ({
  model: modelName,
  }: Args): ActionTypes {
  const name = modelName.toLowerCase()

  return {
    add: function (): string {
      return `${prefix}/${name}/${ADD}`
    },
    edit: function (): string {
      return `${prefix}/${name}/${EDIT}`
    },
    delete: function (): string {
      return `${prefix}/${name}/${DELETE}`
    },
    read: function (): string {
      return `${prefix}/${name}/${READ}`
    },
    updateOperation: function (): string {
      return `${prefix}/${name}/${UPDATE_OPERATION}`
    },
    updateOperations: function (): string {
      return `${prefix}/${name}/${UPDATE_OPERATIONS}`
    },
    cancelOperation: function (): string {
      return `${prefix}/${name}/${CANCEL_OPERATION}`
    },
    cancelOperations: function (): string {
      return `${prefix}/${name}/${CANCEL_OPERATIONS}`
    },
    submitOperation: function (): string {
      return `${prefix}/${name}/${SUBMIT_OPERATION}`
    },
    submitOperations: function (): string {
      return `${prefix}/${name}/${SUBMIT_OPERATIONS}`
    },
  }
}
